import { MapCoords } from '../../features/map/types';
import { FAQ } from './common';

export interface CompoundOld {
  id: number;
  name: string;
  slug: string;
  area_id: string;
  all_slugs: { ar: string; en: string };
  amenities: [];
  area: any; // to be updated with the area type
  child_compounds: [];
  compound_images: { id: number; image_path: string }[];
  cover_image_path: string;
  currency: string;
  description: string;
  developer: any; // to be updated with the developer type
  developer_id: number;
  display_name: string;
  features: [];
  has_offer: boolean;
  is_super: boolean;
  lat: number;
  long: number;
  max_price: number;
  min_price: number;
  resale_min_price: number;
  offers: [];
  compound_offers: [];
  parent_compound?: {
    id?: number;
    location_point?: number[];
    name?: string;
    polygon_points?: MapCoords[][] | null;
  };
  parent_compound_id?: number;
  payment_plans: PaymentInterface[];
  phases: [];
  properties_count: number;
  map_path: string;
  video: { url: string };
  nawy_organization_id?: number | null;
  on_sahel_map?: boolean;
  polygon_points?: MapCoords[][] | null;
  primary_min_price: number;
}

export interface Compound {
  id: number;
  isSuper: boolean;
  masterPlan: string;
  images: string[];
  name: string;
  displayName: string;
  slug: string;
  slugEn: string;
  slugAr: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  long: number;
  lat: number;
  coordinates: MapCoords[][];
  geometry: {
    type: string;
    coordinates: MapCoords[][][] | MapCoords[][] | MapCoords[];
  };
  areaName: string;
  areaId: number;
  areaSlug: string;
  developerId: number;
  developerName: string;
  developerLogoUrl: string;
  extraFeatures: [];
  parentCompound: {
    id: number;
    long: number;
    lat: number;
    coordinates: [number, number];
    geometry: {
      type: string;
      coordinates: number[][][];
    };
  };
  propertiesCount: number;
  prices: {
    developerStartingPrice: number;
    resaleStartingPrice: number;
    minPrice: number;
    maxPrice: number;
    currency: string;
  };
  phases: Phase[];
  paymentPlans: PaymentInterfaceNew[];
  faqs: FAQ[];
  amenities: Amenity[];
  offers: Offer[];
  coverImageUrl: string;
  nawyOrganizationId: number;
  isLaunch: boolean;
  video: string;
  newDesign: boolean;
  onSahelMap: boolean;
  hasNawyNow: boolean;
  coverImageWebUrl: string;
}

export type Phase = {
  name: string;
  slug: string;
  imageUrl: string;
  propertiesCount: number;
};

export type Amenity = {
  name: string;
  imageUrl: string;
};

export type Offer = {
  isNawyExclusive: boolean;
  description: string;
  cashDiscountPercentage: number;
  discountPercentage: number;
  downPaymentPercentage: number;
  installmentPercentage: number;
  years: number;
  isBackLoaded: true;
  originalDownPaymentPercentage: number;
  originalYears: number;
};

export type Entity = {
  id: number;
  slug: string;
  name: string;
};

export interface PaymentInterfaceNew {
  installmentPercentage: number;
  downPaymentPercentage: number;
  years: number;
  isBackLoaded: boolean;
  nawyNow: boolean;
  isCash: boolean;
}

export interface PaymentInterface {
  id: number;
  name: string;
  description: string;
  installment_type: { id: number; name: string };
  equal_installments: { value: number };
  down_payment: { value: number; percent: number };
  cash_discount: { value: number; percent: number };
  years: number;
  months: number;
  original_payment_plan: PaymentInterface;
  years_remaining: number;
  price: number;
  currency: string;
  is_cash: boolean | null;
  is_nawy_now: boolean;
}

export type EntityOffer = {
  id: number;
  nawy_exclusive: boolean;
  description: string;
  compound: Entity;
  developer: Entity;
  discount: number;
  offer: PaymentInterface;
  original_payment_plan: PaymentInterface;
};

export interface Image {
  id: number;
  cover_photo: boolean;
  image_name: string;
  image_path: string;
  low_quality_image_name: string;
  low_quality_image_path: string;
  medium_quality_image_name: string;
  medium_quality_image_path: string;
}

export enum EntityDetailsTypes {
  MAP = 'map',
  FLOOR_PLAN = 'floor_plan',
  GALLERY = 'gallery',
  MASTER_PLAN = 'master_plan'
}

export enum Availability {
  InStock = 'InStock',
  OutOfStock = 'OutOfStock'
}
